import React, { useState, useRef, useEffect } from 'react';
import './MagicCursor.scss';

interface Particle {
  id: number;
  x: number;
  y: number;
  life: number;
}

const MagicCursor: React.FC = () => {
  const [cursorPos, setCursorPos] = useState({ x: 0, y: 0 });
  const [particles, setParticles] = useState<Particle[]>([]);
  const particleIdRef = useRef(0);

  // Track cursor position
  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      setCursorPos({ x: e.clientX, y: e.clientY });

      // Create particle trail
      const newParticle: Particle = {
        id: particleIdRef.current++,
        x: e.clientX,
        y: e.clientY,
        life: 1,
      };

      setParticles((prev) => [...prev, newParticle]);
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  // Particle lifecycle
  useEffect(() => {
    const interval = setInterval(() => {
      setParticles((prev) =>
        prev
          .map((p) => ({ ...p, life: p.life - 0.05 }))
          .filter((p) => p.life > 0)
      );
    }, 50);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      {/* Cursor trail particles */}
      {particles.map((particle) => (
        <div
          key={particle.id}
          className="magic-cursor__particle"
          style={{
            left: particle.x,
            top: particle.y,
            opacity: particle.life,
            transform: `translate(-50%, -50%) scale(${particle.life})`,
          }}
        />
      ))}

      {/* Main cursor */}
      <div
        className="magic-cursor"
        style={{
          left: cursorPos.x,
          top: cursorPos.y,
        }}
      >
        <div className="magic-cursor__inner" />
      </div>
    </>
  );
};

export default MagicCursor;
